module.exports = __webpack_public_path__ + "img/cockroach_chart01.0e08606a.jpg";